/**
 * Created by slava on 19/3/20
 */

const UndoButton = cleverapps.UI.Button.extend({
    ctor: function (options) {
        const baseOptions = this.getOptions();
        baseOptions.onClicked = options.onPressed;

        this._super(baseOptions);
    },

    getOptions: function () {
        const styles = cleverapps.styles.UndoButton;
        const base = {
            width: styles.width,
            height: styles.height
        };

        base.spine = bundles.game.jsons.undo_button_json;

        return base;
    }
});

cleverapps.styles.UndoButton = {
    width: 78,
    height: 78
};